import * as Types from '../../../modules/decisionsNext/api/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type UpsertPolicyFilterMutationVariables = Types.Exact<{
  input: Types.UpsertPolicyFilter;
}>;


export type UpsertPolicyFilterMutation = { __typename?: 'Mutation', upsertPolicyFilter: { __typename?: 'StoredPolicyFilter', id: string, name: string, lastUsed?: number | string | null, tag: string, type: Types.StoredFilterType } };

export type ReorderPolicyFiltersMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  tag: Types.Scalars['String']['input'];
}>;


export type ReorderPolicyFiltersMutation = { __typename?: 'Mutation', reorderSavedPolicyFilters: boolean };


export const UpsertPolicyFilterDocument = gql`
    mutation UpsertPolicyFilter($input: UpsertPolicyFilter!) {
  upsertPolicyFilter(input: $input) {
    id
    name
    lastUsed
    tag
    type
  }
}
    `;
export type UpsertPolicyFilterMutationFn = Apollo.MutationFunction<UpsertPolicyFilterMutation, UpsertPolicyFilterMutationVariables>;

/**
 * __useUpsertPolicyFilterMutation__
 *
 * To run a mutation, you first call `useUpsertPolicyFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPolicyFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPolicyFilterMutation, { data, loading, error }] = useUpsertPolicyFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPolicyFilterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertPolicyFilterMutation, UpsertPolicyFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertPolicyFilterMutation, UpsertPolicyFilterMutationVariables>(UpsertPolicyFilterDocument, options);
      }
export type UpsertPolicyFilterMutationHookResult = ReturnType<typeof useUpsertPolicyFilterMutation>;
export type UpsertPolicyFilterMutationResult = Apollo.MutationResult<UpsertPolicyFilterMutation>;
export type UpsertPolicyFilterMutationOptions = Apollo.BaseMutationOptions<UpsertPolicyFilterMutation, UpsertPolicyFilterMutationVariables>;
export const ReorderPolicyFiltersDocument = gql`
    mutation ReorderPolicyFilters($ids: [ID!]!, $tag: String!) {
  reorderSavedPolicyFilters(ids: $ids, tag: $tag)
}
    `;
export type ReorderPolicyFiltersMutationFn = Apollo.MutationFunction<ReorderPolicyFiltersMutation, ReorderPolicyFiltersMutationVariables>;

/**
 * __useReorderPolicyFiltersMutation__
 *
 * To run a mutation, you first call `useReorderPolicyFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPolicyFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPolicyFiltersMutation, { data, loading, error }] = useReorderPolicyFiltersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useReorderPolicyFiltersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderPolicyFiltersMutation, ReorderPolicyFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReorderPolicyFiltersMutation, ReorderPolicyFiltersMutationVariables>(ReorderPolicyFiltersDocument, options);
      }
export type ReorderPolicyFiltersMutationHookResult = ReturnType<typeof useReorderPolicyFiltersMutation>;
export type ReorderPolicyFiltersMutationResult = Apollo.MutationResult<ReorderPolicyFiltersMutation>;
export type ReorderPolicyFiltersMutationOptions = Apollo.BaseMutationOptions<ReorderPolicyFiltersMutation, ReorderPolicyFiltersMutationVariables>;